module.exports = __webpack_public_path__ + "img/ic-empty.d0359cef.svg";